import { Box, Typography } from '@mui/material'
import React from 'react'
import '../../styles/ContactUs.scss'
const ContactUS = () => {
    const contactusList = [
        { name: 'North India', value: '011-411-83866 (10:30 AM to 08:30 PM)' },
        { name: 'Rajasthan', value: '079-480-61655 (10:30 AM to 08:30 PM)' },
        { name: 'Gujarat', value: '079-480-61655 (10:30 AM to 08:30 PM)' },
        { name: 'Maharashtra and Goa', value: '020-715-31448 (10:30 AM to 08:30 PM)' },
        { name: 'Vidharbha and Chhattisgarh', value: '020-715-31448 (10:30 AM to 08:30 PM)' },
        { name: 'Madhya Pradesh', value: '073-148-54988 (10:30 AM to 08:30 PM)' },
        { name: 'South India', value: '080-470-96674 (10:30 AM to 08:30 PM)' },
        { name: 'Rest of India', value: '080-470-96674 (10:30 AM to 08:30 PM)' },
    ]
    return (
        <Box className='contactUS'>
            <Box className='header'>
                <Box>
                    <img src="./maventech-logo.png" alt="logo" />
                </Box>
                <Box sx={{ paddingX: '4px' }}>
                    <Typography sx={{ color: '#24B24B !important', fontSize: '16px !important' }}>Maventech Labs Private Limited</Typography>
                    <Typography >Gopala Krishna Complex, 1st Floor, #45/3 Residency Road, Bangaluru - 560025, Karnataka, India.</Typography>
                </Box>
            </Box>
            <Box sx={{ backgroundColor: '#e5f6fd' }}>
                <Box sx={{ paddingY: '12px', textAlign: 'center' }}>
                    <p style={{ fontSize: '16px ', color: '#000', fontWeight: '600' }}>Contact US</p>
                </Box>
                {contactusList.map((obj) => (
                    <Box className='list-section'>
                        <Typography sx={{ fontWeight: '700 !important' }}>{obj.name}</Typography>
                        <Typography >{obj.value}</Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    )
}

export default ContactUS